export default [
  {
    name: 'signoutAuto',
    path: '/signout/auto',
    meta: {
      requireSignin: false,
    },
    component() {
      return import('@/pages/signout/Auto.vue')
    },
  },
]
